import { Box } from '@mui/material';
import { ServicesProvider } from '@/contexts/ServicesContext';
import AppRouter from '@/router/AppRouter';

function App() {
  return (
    <ServicesProvider>
      <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
        <AppRouter />
      </Box>
    </ServicesProvider>
  );
}

export default App;
